export enum WorkTypeCategory {
  EPIC = 'EPIC',
  STORY = 'STORY',
  TASK = 'TASK',
  SUB_TASK = 'SUB_TASK',
  BUG = 'BUG',
}

export enum WorkStatusCategory {
  TODO = 'TODO',
  IN_PROGRESS = 'IN_PROGRESS',
  DONE = 'DONE',
}

export interface WorkType {
  status: boolean;
  workTypeUuid: string;
  name: string;
  workTypeCategory: WorkTypeCategory;
}

export interface WorkStatus {
  status: boolean;
  workStatusUuid: string;
  name: string;
  workStatusCategory: WorkStatusCategory;
  workStatusColorKey?: string;
  statusOrder?: number;
  isDefault?: boolean;
}


export interface ProjectDefaults {
  status: boolean;
  projectUuid: string;
  workTypeDTOList: WorkType[];
  workStatusDTOList: WorkStatus[];
}

export interface ProjectDefaultsResponse {
  response: ProjectDefaults;
}
